import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { InputPicker, Panel, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplaySelectPickerItem = ({ register, tc, icon, options, onChange, disabled, borderOff }) => {
  const [value, setValue] = useState(/** @type {any} */ (null));

  const updateValue = (value, event) => {
    devLog(event, value);
    setValue(value);
    onChange(register, value);
  };

  useEffect(() => {
    setValue(register.value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />

        <Flex justifyContent="between" className="space-x-4">
          <div>
            <Text color={tc} className="truncate">
              {register.title}
            </Text>
            <Text color={tc} className="truncate">
              <Bold>{register.display}</Bold>
            </Text>
          </div>
          <div
            style={{
              display: 'block',
              width: '50%',
            }}
          >
            <InputPicker
              block
              cleanable={false}
              searchable={false}
              placement="autoVerticalStart"
              data={options}
              value={value}
              disabled={disabled}
              onChange={updateValue}
            />
          </div>
        </Flex>
      </Flex>
    </Panel>
  );
};
